/**
 * Returns a new mode based on the current mode of the column
 * @param {String} mode - A name of the current mode
 * @param {Boolean} shouldDive - Determines if it needs to dive to 1-hour(h) period
 * @returns {String} The new mode
 */
function getNewMode(mode, shouldDive) {
  /* 8-hour(p) to 3-hour(t) */
  if (mode === 'p') return 't';
  /* 1-hour(h) to 3-hour(t) */
  if (mode === 'h') return 't';

  /* 3-hour(t) to 1-hour(h) */
  if (shouldDive) return 'h';
  /* 3-hour(t) to 8-hour(p) */
  return 'p';
}

export default getNewMode;
